import {IBackendWallet} from '../models/BackendWallet';

export const FETCH_BACKEND_WALLETS = 'FETCH_BACKEND_WALLETS';
export const FETCH_BACKEND_WALLETS_SUCCESS = 'FETCH_BACKEND_WALLETS_SUCCESS';
export const FETCH_BACKEND_WALLETS_ERROR = 'FETCH_BACKEND_WALLETS_ERROR';

export interface FetchBackendWallets {
  type: typeof FETCH_BACKEND_WALLETS;
}

export interface FetchBackendWalletsSuccess {
  type: typeof FETCH_BACKEND_WALLETS_SUCCESS;
  payload: IBackendWallet[];
}

export interface FetchBackendWalletsError {
  type: typeof FETCH_BACKEND_WALLETS_ERROR;
}

export type BackendWalletsActions =
  | FetchBackendWallets
  | FetchBackendWalletsSuccess
  | FetchBackendWalletsError;
